import React, { useEffect, useState } from "react";
import { ContentState, Editor, EditorState, RichUtils, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import BlockStyleControls from "./components/block-style-controls";
import InlineStyleControls from "./components/inline-style-controls";

import "./rich-text.scss";

const RichText = (props) => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    useEffect(() => {
        if (props.defaultValue) {
            const blocksFromHtml = htmlToDraft(props.defaultValue);
            const { contentBlocks, entityMap } = blocksFromHtml;
            const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
            const newState = EditorState.createWithContent(contentState);
            setEditorState(newState);
        }
    }, []);

    const onChange = (newState) => {
        setEditorState(newState);
    };

    const onBlur = () => {
        const raw = convertToRaw(editorState.getCurrentContent());
        props.updateOnChange(props.name, draftToHtml(raw));
    };

    const handleKeyCommand = (command) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);

        if (newState) {
            onChange(newState);

            return "handled";
        }

        return "not-handled";
    };

    const toggleBlockType = (blockType) => {
        onChange(RichUtils.toggleBlockType(editorState, blockType));
    };
    const toggleInlineStyle = (inlineStyle) => {
        onChange(RichUtils.toggleInlineStyle(editorState, inlineStyle));
    };

    return (
        <div className="rich-text-editor">
            {!props.readOnly && (
                <div className="rich-text-controls">
                    <InlineStyleControls editorState={editorState} onToggle={toggleInlineStyle} />
                    <BlockStyleControls editorState={editorState} onToggle={toggleBlockType} />
                </div>
            )}
            <Editor
                editorState={editorState}
                onChange={onChange}
                onBlur={onBlur}
                handleKeyCommand={handleKeyCommand}
                readOnly={props.readOnly}
                customStyleMap={{
                    SUBSCRIPT: { fontSize: "0.6em", verticalAlign: "sub" },
                    SUPERSCRIPT: { fontSize: "0.6em", verticalAlign: "super" },
                }}
            />
        </div>
    );
};

export default RichText;
